"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startGlobalContext = startGlobalContext;
exports.buildGlobalContextManager = buildGlobalContextManager;
const storeContextManager_1 = require("../context/storeContextManager");
const contextManager_1 = require("../context/contextManager");
function startGlobalContext(hooks, configuration, productKey, useContextNamespace) {
    const globalContextManager = buildGlobalContextManager();
    if (configuration.storeContextsAcrossPages) {
        (0, storeContextManager_1.storeContextManager)(configuration, globalContextManager, productKey, 2 /* CustomerDataType.GlobalContext */);
    }
    hooks.register(0 /* HookNames.Assemble */, () => {
        const context = globalContextManager.getContext();
        return useContextNamespace ? { context } : context;
    });
    return globalContextManager;
}
function buildGlobalContextManager() {
    return (0, contextManager_1.createContextManager)('global context');
}
//# sourceMappingURL=globalContext.js.map